import { useEffect, useState, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Header from './Components/Header';
import Hero from './Components/Hero';
import KeyFeatures from './Components/KeyFeatures';
import CloudComputing from './Components/CloudComputing';
import KeyFeat from './Components/KeyFeat';
import WhyUs from './Components/WhyUs';
import Footer from './Components/Footer';
import Demo from './Components/Demo';
import { ToastContainer } from 'react-toastify';
import { MdArrowDownward } from 'react-icons/md';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from 'react-router-dom';
import PaymentCallback from './Components/PaymentCallback';
import ReactGA4 from 'react-ga4';
import ForceChangePassword from './Components/auth/ForceChangePassword';
// Auth Components
import Login from './Components/auth/Login';
import ProtectedRoute from './Components/auth/ProtectedRoute';
import IdleTimeout from './Components/auth/IdleTimeout';
import AdminDashboard from './Components/admin/AdminDashboard';
import HostingPricing from './Components/HostingPricing';
import { authService } from './Components/services/auth';
import NotificationsPage from './Components/notifications/NotificationsPage';
import NotificationDetailPage from './Components/notifications/NotificationDetailPage';
import SubscriptionDetailPage from './Components/admin/SubscriptionDetailPage';
const HomePage = ({ handleBookDemo, handleContactSpecialist, demoRef, pricingRef }) => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const location = useLocation();

  const handleScroll = () => {
    const newScrollPosition = scrollPosition + window.innerHeight;
    window.scrollTo({
      top: newScrollPosition,
      behavior: 'smooth'
    });
    setScrollPosition(newScrollPosition);
  };

  // Track pageview on route change
  useEffect(() => {
    ReactGA4.send('pageview', location.pathname + location.search);
  }, [location]);

  return (
    <div className="bg-main-gradient from-bgColorTwo flex flex-col to-bgMainColor">
      <Header 
        handleBookDemo={handleBookDemo} 
        handleContactSpecialist={handleContactSpecialist}  // Pass this to Header
      />
      <Hero />
      <KeyFeatures />
      <CloudComputing />
      <KeyFeat />
      <WhyUs />
      
      {/* Add ref to HostingPricing */}
      <div ref={pricingRef}>
        <HostingPricing />
      </div>
      
      <div ref={demoRef}>
        <Demo />
      </div>
      
      <Footer />

      <div
        className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-10 cursor-pointer"
        onClick={handleScroll}
      >
        <div className="p-2 bg-bgColor text-white rounded-full shadow-lg animate-bounce">
          <MdArrowDownward size={30} />
        </div>
      </div>
    </div>
  );
};

const HomeRoute = ({ handleBookDemo, handleContactSpecialist, demoRef, pricingRef }) => {
  if (authService.isAuthenticated()) {
    return <Navigate to="/admin" replace />;
  }
  return (
    <HomePage
      handleBookDemo={handleBookDemo}
      handleContactSpecialist={handleContactSpecialist}
      demoRef={demoRef}
      pricingRef={pricingRef}
    />
  );
};

const App = () => {
  const [loading, setLoading] = useState(true);
  
  // Create refs
  const demoRef = useRef(null);
  const pricingRef = useRef(null);  // ← New ref for HostingPricing

  // Scroll to Demo
  const handleBookDemo = () => {
    demoRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  // Scroll to HostingPricing (Contact Specialist)
  const handleContactSpecialist = () => {
    pricingRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  // Loading simulation
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        <IdleTimeout />
        <Routes>
          <Route path="/login" element={<Login />} />
            <Route path="/force-change-password" element={<ForceChangePassword />} />
                    <Route
            path="/"
            element={
              <HomeRoute
                handleBookDemo={handleBookDemo}
                handleContactSpecialist={handleContactSpecialist}
                demoRef={demoRef}
                pricingRef={pricingRef}
              />
            }
          />

          <Route
            path="/admin"
            element={
              <ProtectedRoute requireAdmin={true}>
                <AdminDashboard />
                          </ProtectedRoute>
                        }
                      />
                      <Route
              path="/notifications"
              element={
                <ProtectedRoute requireAdmin={true}>
                  <NotificationsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/subscription/:id"
              element={
                <ProtectedRoute requireAdmin={true}>
                  <SubscriptionDetailPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/notifications/:id"
              element={
                <ProtectedRoute requireAdmin={true}>
                  <NotificationDetailPage />
                </ProtectedRoute>
              }
            />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

            <Route path="/payment/callback" element={<PaymentCallback />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        <ToastContainer
          position="top-left"
          autoClose={5000}
          hideProgressBar={false}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </Router>
  );
};

export default App;